/**
 * The three languages the product ships in, in switcher order.
 * Text labels, never flags — see the design-system readme.
 */
export const LANGUAGES = ['uz', 'ru', 'en']

export const LANG_LABELS = { uz: "O'z", ru: 'Ру', en: 'En' }

/** Full names, announced to screen readers in place of the short labels. */
export const LANG_NATIVE_NAMES = { uz: "O'zbekcha", ru: 'Русский', en: 'English' }
